import React from 'react';

import { cn } from 'domain/core';
import { DivProps } from './common-types';

/**
 * Flex component with flex-direction: row and items centered
 */
export const Row = React.forwardRef((props: DivProps, ref: any) => {
	const { className, ...otherProps } = props;

	return (
		<div
			className={cn(
				'box-border flex w-full flex-row items-center justify-center gap-4',
				className
			)}
			{...otherProps}
			ref={ref}>
			{props.children}
		</div>
	);
});

/**
 * Flex component with flex-direction: column and items centered
 */
export const Col = React.forwardRef((props: DivProps, ref: any) => {
	const { className, ...otherProps } = props;

	return (
		<div
			className={cn(
				'box-border flex h-full w-full flex-col justify-start gap-4',
				className
			)}
			{...otherProps}
			ref={ref}>
			{props.children}
		</div>
	);
});
